import { message } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'

export const handleSave = ({
  setIsLoading,
  saveVariableValues,
  onClose,
  setShowAlert,
  sendUserDataToGTM,
}) => {
  setIsLoading(true)
  setShowAlert &&
    setShowAlert((prevState) => {
      return { ...prevState, rule: true }
    })
  saveVariableValues()
    .then(() => {
      message.success(i18n.t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
      onClose()
      setShowAlert &&
        setShowAlert((prevState) => {
          return { ...prevState, rule: false }
        })
      sendUserDataToGTM()
    })
    .catch((error) => {
      message.error(generateMessageError(error, 'FEEDBACK_SAVE_CHANGES_FAIL'), 8)
      onClose()
      setShowAlert &&
        setShowAlert((prevState) => {
          return { ...prevState, rule: false }
        })
    })
}

export const handleAction = ({
  setIsLoading,
  action,
  onRefetchRules,
  text,
  onClose,
  setShowAlert,
  sendUserDataToGTM,
}) => {
  setIsLoading(true)
  setShowAlert &&
    setShowAlert((prevState) => {
      return { ...prevState, rule: true }
    })
  action()
    .then(() =>
      onRefetchRules().then(() => {
        setTimeout(() => {
          message.success(i18n.t('PLANNING_RULES_APPLY_SUCCESS_FEEDBACK', { action: text }), 8)
          onClose()
          setShowAlert &&
            setShowAlert((prevState) => {
              return { ...prevState, rule: false }
            })
        }, 1000)
        sendUserDataToGTM?.()
      }),
    )
    .catch((error) => {
      message.error(
        generateMessageError(error, 'PLANNING_RULES_APPLY_ERROR_FEEDBACK', { action: text }),
        8,
      )
      onClose()
      setShowAlert &&
        setShowAlert((prevState) => {
          return { ...prevState, rule: false }
        })
    })
}
